import { render } from "./fourPage.vue?vue&type=template&id=e1437f74&scoped=true"
import script from "./fourPage.vue?vue&type=script&lang=js"
export * from "./fourPage.vue?vue&type=script&lang=js"

import "./fourPage.vue?vue&type=style&index=0&id=e1437f74&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1437f74"]])

export default __exports__